import React from "react";
import PageWithSidebar from "../Various/Sidebar/PageWithSidebar";
import AccountAreaSidebar from "./AccountAreaSidebar";

function PageWithAccountAreaSidebar({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PageWithSidebar sidebar={<AccountAreaSidebar />}>
      <section className="px-12 lg:px-24 py-2 md:py-12">{children}</section>
    </PageWithSidebar>
  );
}

export default PageWithAccountAreaSidebar;
